<template>
  <div id="app" :class="{ 'is-md': isMd() }">
    <transition :name="transitionName" mode="out-in">
      <keep-alive>
        <router-view :key="`page-${$route.path}`" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  import { get } from 'lodash'
  import { mapActions, mapState } from 'vuex'
  import objectFitImages from 'object-fit-images'
  import responsive from '@/mixins/responsive'
  import appendAdditionalScripts from '@/assets/js/appendScripts'
  import { isMd } from '@/helpers/constant'

  export default {
    name: 'App',
    mixins: [responsive],

    data () {
      return {
        componentReady: false,
        transitionName: 'slide-to-right'
      }
    },

    computed: {
      ...mapState({
        scripts: state => state.general.scripts
      }),
      isIframe () {
        try {
          return window.self !== window.top
        } catch (e) {
          return true
        }
      }
    },

    watch: {
      $route (to, from) {
        let toDepth = to.path.split('/').length
        let fromDepth = from.path.split('/').length

        toDepth = to.path === '/' ? 0 : toDepth
        fromDepth = from.path === '/' ? 0 : fromDepth

        let goToLeft = toDepth < fromDepth

        if (to.path === '/policy' || to.path === '/thank-you') {
          goToLeft = false
        }

        if (from.path === '/policy' || from.path === '/thank-you') {
          goToLeft = true
        }

        this.transitionName = goToLeft
          ? 'slide-to-left' : 'slide-to-right'

        if (document.querySelector('body')) {
          document.querySelector('body').scrollTop = 0
        }
      }
    },

    async mounted () {
      setInterval(() => {
        window.parent.window.postMessage({
          type: 'dxp-screens-iframe-activity'
        }, '*')
      }, 5000)

      setTimeout(() => {
        if (get(this.$route, 'query.dealerId') || get(this.$route, 'query.dealerName') || get(this.$route, 'query.dealer')) {
          window.iframe = true
        } else {
          window.iframe = false
        }
      }, 1000)
      await this.fetchGeneralData()

      appendAdditionalScripts(this.scripts)

      const hasHover = window.matchMedia('(hover: hover)').matches
      if (hasHover) {
        document.documentElement.classList.add('has-hover')
      }

      objectFitImages() // object-fit polyfill

      this.componentReady = true

      if (this.$route.query.city) {
        this.$store.commit('SET_ALIAS_PARAM_CITY', this.$route.query.city)

        if (this.$route.query.dealer) {
          this.$store.commit('SET_ALIAS_PARAM_DEALER', this.$route.query.dealer)
        }
      }
    },

    methods: {
      isMd () {
        return isMd
      },
      ...mapActions(['fetchGeneralData'])
    }
  }
</script>

<style lang="scss">
  #app {
    padding-top: 35px;
    padding-bottom: 270px;
    // margin-bottom: 45px;

    @include mobile {
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }

  #app.is-md {
    padding-top: 55px;
    padding-bottom: 270px;

    @include mobile {
      margin-top: 35px;
      margin-bottom: 15px;
    }
  }

  .modals {
    z-index: 999999;
    position: fixed;
  }

</style>
